<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.26</b> - Font sizes, performance & bug fixes</p>
    <div class="ml-5 pb-4 text-yellow-300">
      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>Increased font sizes and improved text readability throughout the game</li>
      </ul>

      <div class="font-bold mt-2">Battle AI</div>
      <ul class="ml-4 list-disc">
        <li>Fixed a bug causing Ranged DPS to skip turns.</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes & Performance</div>
      <ul class="ml-4 list-disc">
        <li>Fixed battle view display issues when tabbing out and back into the game.</li>
        <li>Inn: fixed players getting stuck in embattled state.</li>
        <li>Fixed & optimized Inn tournament state updater.</li>
        <li>Fixed Inn tournament rewards claiming.</li>
        <li>Fixed several UI memory leaks & other bugs on tearing down UI screens.</li>
      </ul>
    </div>
  </div>
</template>
